export const TRUSTPILOT_RATING_VALUE = 4.8;
export const TRUSTPILOT_RATING_COUNT = '545';
